// removed by extract-text-webpack-plugin
module.exports = {"button":"button__2_KA6","button__inverted":"button__inverted__1A0F5","button__underline":"button__underline__1sL9D","button__fullWidth":"button__fullWidth__-y67M"};


//////////////////
// WEBPACK FOOTER
// ./components/Parts/Button.scss
// module id = OuTC
// module chunks = 0